import { ENVIRONMENT } from 'settings';

export const getPasswordPolicyErrors = (password?: string) => {
  const errors = [];
  const value = password || '';

  if (value.length < 8) {
    errors.push('Password must be at least 8 characters long.');
  }
  if (!/[A-Z]/.test(value)) {
    errors.push('Password must contain at least one capital letter.');
  }
  if (!/[0-9]/.test(value)) {
    errors.push('Password must contain at least one digit.');
  }
  if (!/[^A-Za-z0-9]/.test(value)) {
    errors.push('Password must contain at least one special character.');
  }

  return errors;
};

export const passwordFormRules = [
  { required: true, message: 'Please input a password!' },
  {
    validator: (_: unknown, value?: string) => {
      if (!value) return Promise.resolve();
      const errors = getPasswordPolicyErrors(value);
      if (errors.length) return Promise.reject(errors[0]);
      return Promise.resolve();
    },
  },
];

// Class creation allows simple development passwords only on the local API.
export const classPasswordFormRules =
  ENVIRONMENT === 'local' ? [passwordFormRules[0]] : passwordFormRules;
